export const EVENTS = {
  LAYOUT_RESIZE: 'layout.resize',
  DESIGNER_RESIZE: 'designer.resize',
  DESIGNER_ZOOM: 'designer.zoom',
  SHORTCUTS_NAVIGATE: 'shortcuts.navigate',
  DESIGNER_COMPONENT_NAME_VALID: 'designer.component.name.valid',
  DESIGNER_COMPONENT_SAVE_DISABLE: 'designer.component.save.disable',
  DESIGNER_COMPONENT_CLOSE_CLICK: 'designer.component.close.click',
  DESIGNER_COMPONENT_FIELDS_UPDATE: 'designer.component.fields.update',
  DESIGNER_CONTEXT_MENU_SHOW: 'designer.context.menu.show',
  DESIGNER_CONTEXT_MENU_HIDE: 'designer.context.menu.hide',
  SHORTCUTS_DISPLAY_LIST: 'shortcuts.display.list',
  SHORTCUTS_DESIGNER_SAVE: 'shortcuts.designer.save',
  SHORTCUTS_DESIGNER_SELECT_ALL: 'shortcuts.designer.select.all',
  SHORTCUTS_DESIGNER_SELECT_VERTICAL_ALIGN: 'shortcuts.designer.select.vertical.align',
  SHORTCUTS_DESIGNER_UNDO: 'shortcuts.designer.undo',
  SHORTCUTS_DESIGNER_REDO: 'shortcuts.designer.redo',
  SHORTCUTS_DESIGNER_CUT: 'shortcuts.designer.cut',
  SHORTCUTS_DESIGNER_COPY: 'shortcuts.designer.copy',
  SHORTCUTS_DESIGNER_PASTE: 'shortcuts.designer.paste',
  SHORTCUTS_DESIGNER_UNSELECT: 'shortcuts.designer.unselect',
  SHORTCUTS_DESIGNER_ZOOM_IN: 'shortcuts.designer.zoomin',
  SHORTCUTS_DESIGNER_ZOOM_OUT: 'shortcuts.designer.zoomout',
  SHORTCUTS_DESIGNER_ZOOM_RESET: 'shortcuts.designer.zoomreset',
  SPLITTER_RESIZE_STARTED: 'splitter.resize.started',
  SPLITTER_RESIZE_COMPLETED: 'splitter.resize.completed',
  SCROLL_REACH_END: 'scroll.reach.end',
  SCROLL_UPDATE: 'scroll.update',
  SCROLL_ENABLE: 'scroll.enable',
  SCROLL_DISABLE: 'scroll.disable',
  GENERIC_LIST_SEARCH_QUERY: 'generic.list.search.query',
  GENERIC_LIST_CANCEL_SEARCH: 'generic.list.cancel.search',
  GENERIC_LIST_ADD_ITEM: 'generic.list.add.item',
  GENERIC_LIST_UPDATE_ITEM: 'generic.list.update.item',
  GENERIC_LIST_REMOVE_ITEM: 'generic.list.remove.item',
  GENERIC_LIST_NEW_BUTTON_CLICK: 'generic.list.new.button.click',
  GENERIC_LIST_ORDER_REQUEST: 'generic.list.order.request',
  CONNECTION_CREATED: 'connection.created',
  CONNECTION_UPDATED: 'connection.updated',
  CONNECTION_TYPES_LOADED: 'connection.types.loaded',
  CONNECTION_AUTHENTICATE_COMPLETE: 'connection.authenticate.complete',
  DESIGNER_COMPONENT_ADDED: 'designer.component.added',
  CLUSTER_CREATED: 'cluster.created',
  CLUSTER_UPDATED: 'cluster.updated',
  CLUSTER_FORM_NODES_SIZE_CHANGED: 'cluster.form.nodes.size.changed',
  WIZARD_GO_NEXT_STEP: 'wizard.go.next.step',
  TERMINAL_TOGGLE: 'terminal.toggle',
  JOB_VARIABLES_LOADED: 'job.variables.loaded',
  PACKAGE_VARIABLES_SAVE: 'package.variables.save',
  PACKAGES_SELECTOR_CHANGE: 'packages.selector.change',
  MODAL_PANEL_CLOSE_CLICK: 'modal.panel.close.click',
  MODAL_PANEL_SAVE_CLICK: 'modal.panel.save.click',
  MODAL_PANEL_CLOSE: 'modal.panel.close',
  MODAL_PANEL_CLOSED: 'modal.panel.closed',
  MODAL_CLOSE: 'modal.close',
  EXPRESSION_EDITOR_SHOW: 'expression.editor.show',
  EXPRESSION_EDITOR_SAVE: 'expression.editor.save',
  EXPRESSION_EDITOR_CLOSE: 'expression.editor.close',
  ACCOUNT_LOADED: 'account.loaded',
  HOOKS_LOADED: 'hooks.list.loaded',
  REGIONS_LIST_LOADED: 'regions.list.loaded',
  AUTH_CALLBACK: 'auth.callback',
  CARD_CONFIRMED: 'card.confirmed',
  PLAN_CHANGED: 'plan.changed',
  SHORTCUTS_QUICK_FIND: 'shortcuts.quick_find',
  SCHEMA_IMPORTER_LOADING_STARTED: 'schema.importer.loading.started',
  SCHEMA_IMPORTER_LOADING_ENDED: 'schema.importer.loading.ended',
  SCHEMA_IMPORTER_LOADED: 'schema.importer.loaded',
  SCHEMA_IMPORTER_ERROR: 'schema.importer.error',
  SCHEMA_IMPORTER_ADD_FIELD: 'schema.importer.add.field',
  SCHEMA_IMPORTER_ADD_NEW_FIELD: 'schema.importer.add.new.field',
  SCHEMA_IMPORTER_REMOVE_FIELD: 'schema.importer.remove.field',
  SCHEMA_IMPORTER_GET_SCHEMA: 'schema.importer.get.schema',
  SCHEMA_IMPORTER_TAB_SELECTED: 'schema.importer.tab.selected',
  SCHEMA_IMPORTER_SET_AVAILABLE_FIELDS: 'schema.importer.set.available.fields',
  SCHEMA_IMPORTER_SET_META_DATA_FIELDS: 'schema.importer.set.meta.data.fields',
  SCHEMA_IMPORTER_REFRESH: 'schema.importer.refresh',
  SCHEMA_IMPORTER_CHANGED: 'schema.importer.changed',
  DATA_PREVIEW_REFRESH: 'data.preview.refresh',
  DATA_PREVIEW_ERROR: 'data.preview.error',
  DATA_PREVIEW_DISABLED: 'data.preview.disabled',
  COMPONENTS_ORDER_EDITOR_SWITCH: 'components.order.editor.switch',
  SALESFORCE_OBJECT_PICKER_LOADED: 'salesforce.object.picker.loaded',
  SALESFORCE_OBJECT_PICKER_FIELDS_LOADED: 'salesforce.object.picker.fields.loaded',
  SALESFORCE_OBJECT_PICKER_FIELDS_LOAD_START: 'salesforce.object.picker.fields.load.start',
  NETSUITE_OBJECT_PICKER_LOADED: 'netsuite.object.picker.loaded',
  NETSUITE_OBJECT_PICKER_FIELDS_LOADED: 'netsuite.object.picker.fields.loaded',
  NETSUITE_OBJECT_PICKER_FIELDS_LOAD_START: 'netsuite.object.picker.fields.load.start',
  FACEBOOK_ADS_OBJECT_PICKER_LOADED: 'facebookads.object.picker.loaded',
  FACEBOOK_ADS_OBJECT_PICKER_FIELDS_LOADED: 'facebookads.object.picker.fields.loaded',
  FACEBOOK_ADS_OBJECT_PICKER_FIELDS_LOAD_START: 'facebookads.object.picker.fields.load.start',
  GOOGLE_ADS_OBJECT_PICKER_LOADED: 'google-ads.object.picker.loaded',
  GOOGLE_ADS_OBJECT_PICKER_FIELDS_LOADED: 'google-ads.object.picker.fields.loaded',
  GOOGLE_ADS_OBJECT_PICKER_FIELDS_LOAD_START: 'google-ads.object.picker.fields.load.start',
  TIKTOK_ADS_OBJECT_PICKER_LOADED: 'tiktokads.object.picker.loaded',
  TIKTOK_ADS_OBJECT_PICKER_FIELDS_LOADED: 'tiktokads.object.picker.fields.loaded',
  TIKTOK_ADS_OBJECT_PICKER_FIELDS_LOAD_START: 'tiktokads.object.picker.fields.load.start',
};
